import './App.css';
import { Route, Routes } from 'react-router-dom';
import Main from './components/Main';
import ProjectPage from './components/Projects/ProjectPage.tsx';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Main/>} />
        <Route path="/:slug" element={<ProjectPage/>} />
      </Routes>
    </div>
  );
}

export default App;
